export const campaignsRoutes = {
  path: '/campaigns',
  children: [
    {
      name: 'campaigns',
      path: '',
      component: () => import('pages/Campaigns/Campaigns/index.vue'),
      meta: {
        title: 'Campaigns',
      },
    },
    {
      name: 'newCampaign',
      path: 'new',
      component: () => import('pages/Campaigns/NewCampaign/index.vue'),
      meta: {
        title: 'New Campaign',
      },
    },
    {
      name: 'editCampaign',
      path: ':id/edit',
      component: () => import('pages/Campaigns/EditCampaign/index.vue'),
      meta: {
        title: 'Edit Campaign',
      },
    },
  ],
}
